import { Component, input, ViewEncapsulation } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { NgClass } from '@angular/common';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'unite-maritalstatus-input',
    templateUrl: './maritalstatus-input.component.html',
    styleUrls: ['./maritalstatus-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatFormField, NgClass, MatLabel, MatSelect, ReactiveFormsModule, MatOption, TranslateModule]
})
export class MaritalStatusInputComponent {

  control = input<FormControl>();
  appearance = input<string>('outline');
  class = input<string>('');
  label = input<string>(null);
  hideRequiredMarker = input<boolean>(false);
  showPlaceholder = input(false);

  showValidationError(): boolean {
    return this.control().touched && this.control().valid === false;
  }

}


